export default "__VITE_ASSET__aSoe68wu__"